import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "normalize.css";

ReactDOM.render(<App />, document.getElementById("root"));
